<template>
   <div class="settings-contents">
     <p>No Integrations Found</p>
   </div>
</template>

<script>
export default {

}
</script>

<style>

</style>